import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Home1 from './Pages/Home1';
import AboutUs from './Pages/AboutUs';
import Error from './Pages/Error';
import Projects from './Pages/Projects';
import Gallery from './Pages/Gallery';
import Careers from './Pages/Careers';
import Faq from './Pages/Faq';
import ContactUs from './Pages/ContactUs';
import ScrollToTop from './Common/ScrollToTop';
import ProjectDetail from './Pages/ProjectDetail';
import Admin from './Admin/Admin';
import AdminPanel from './Admin/AdminPanel';

class Components extends React.Component {
    render() {
        return (
            <BrowserRouter basename="/">
                <ScrollToTop />
                <div className="page-wraper">
                        <Routes>
                            <Route path='/' element={<Home1/>} />
                            <Route path='/about-us' element={<AboutUs/>} />
                            <Route path='/error-404' element={<Error/>} />
                            <Route path='/projects' element={<Projects/>} />
                            <Route path='/careers' element={<Careers/>} />
                            <Route path='/gallery' element={<Gallery/>} />
                            <Route path='/faq' element={<Faq/>} />
                            <Route path='/contact-us' element={<ContactUs/>} />
                            <Route element={<Error/>} />
                            <Route path="/:title" element={<ProjectDetail />} />
                            <Route path="/admin" element={<Admin />} />
                            <Route path="/admin-panel" element={<AdminPanel />} />
                        </Routes>
                </div>
            </BrowserRouter>
        );
    };
};

export default Components;